import React, { useState } from 'react';
import { useTheme } from '../../../styles/ThemeContext';

const TopNavBtn = ({ icon: Icon, size = 24, color = "white", bgColor, hoverBgColor }) => {
  const [isHovered, setIsHovered] = useState(false);
  const { theme } = useTheme();
  const actualBgColor = bgColor || theme.accent;
  const actualHoverBgColor = hoverBgColor || theme.accentHighlight;

  // Get shadow colors from theme
  const shadows = theme.shadowColors;

  const handleMouseEnter = () => {
    setIsHovered(true);
  };
  
  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  // Container style with fixed dimensions to prevent layout shifts
  const containerStyle = {
    width: '35px',
    height: '36px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative'
  };

  return (
    <div style={containerStyle}>
      {isHovered ? (
        // Hover state SVG
        <svg 
          width="48" 
          height="48" 
          viewBox="0 0 68 68" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
          onMouseLeave={handleMouseLeave}
          style={{ position: 'absolute' }}
        >
          <g filter="url(#filter0_ddddii_hover)">
            <circle cx="33" cy="33" r="24" fill={actualHoverBgColor}/>
          </g>
          
          {/* Center the icon */}
          <foreignObject x={33 - size/2} y={33 - size/2} width={size} height={size}>
            <div xmlns="http://www.w3.org/1999/xhtml" style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {React.isValidElement(Icon) ? 
                React.cloneElement(Icon, { size, color }) : 
                <Icon size={size} color={color} />
              }
            </div>
          </foreignObject>
          
          <defs>
            <filter id="filter0_ddddii_hover" x="0" y="0" width="68" height="68" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
              <feFlood floodOpacity="0" result="BackgroundImageFix"/>
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
              <feOffset dx="3" dy="3"/>
              <feGaussianBlur stdDeviation="4"/>
              <feColorMatrix type="matrix" values={`0 0 0 0 ${shadows.dark.r} 0 0 0 0 ${shadows.dark.g} 0 0 0 0 ${shadows.dark.b} 0 0 0 0.9 0`}/>
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_hover"/>
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
              <feOffset dx="-3" dy="-3"/>
              <feGaussianBlur stdDeviation="3"/>
              <feColorMatrix type="matrix" values={`0 0 0 0 ${shadows.light.r} 0 0 0 0 ${shadows.light.g} 0 0 0 0 ${shadows.light.b} 0 0 0 0.9 0`}/>
              <feBlend mode="normal" in2="effect1_dropShadow_hover" result="effect2_dropShadow_hover"/>
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
              <feOffset dx="3" dy="-3"/>
              <feGaussianBlur stdDeviation="3"/>
              <feColorMatrix type="matrix" values={`0 0 0 0 ${shadows.dark.r} 0 0 0 0 ${shadows.dark.g} 0 0 0 0 ${shadows.dark.b} 0 0 0 0.2 0`}/>
              <feBlend mode="normal" in2="effect2_dropShadow_hover" result="effect3_dropShadow_hover"/>
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
              <feOffset dx="-3" dy="3"/>
              <feGaussianBlur stdDeviation="3"/>
              <feColorMatrix type="matrix" values={`0 0 0 0 ${shadows.dark.r} 0 0 0 0 ${shadows.dark.g} 0 0 0 0 ${shadows.dark.b} 0 0 0 0.2 0`}/>
              <feBlend mode="normal" in2="effect3_dropShadow_hover" result="effect4_dropShadow_hover"/>
              <feBlend mode="normal" in="SourceGraphic" in2="effect4_dropShadow_hover" result="shape"/>
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
              <feOffset dx="-1" dy="-1"/>
              <feGaussianBlur stdDeviation="1"/>
              <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
              <feColorMatrix type="matrix" values={`0 0 0 0 ${shadows.dark.r} 0 0 0 0 ${shadows.dark.g} 0 0 0 0 ${shadows.dark.b} 0 0 0 0.5 0`}/>
              <feBlend mode="normal" in2="shape" result="effect5_innerShadow_hover"/>
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
              <feOffset dx="1" dy="1"/>
              <feGaussianBlur stdDeviation="1"/>
              <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
              <feColorMatrix type="matrix" values={`0 0 0 0 ${shadows.light.r} 0 0 0 0 ${shadows.light.g} 0 0 0 0 ${shadows.light.b} 0 0 0 0.3 0`}/>
              <feBlend mode="normal" in2="effect5_innerShadow_hover" result="effect6_innerShadow_hover"/>
            </filter>
          </defs>
        </svg>
      ) : (
        // Normal state SVG
        <svg 
          width="38" 
          height="38" 
          viewBox="0 0 54 54" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
          onMouseEnter={handleMouseEnter}
          style={{ position: 'absolute' }}
        >
          <g filter="url(#filter0_ddiiii_normal)">
            <circle cx="27" cy="27" r="24" fill={actualBgColor}/>
          </g>
          
          {/* Center the icon */}
          <foreignObject x={27 - size/2} y={27 - size/2} width={size} height={size}>
            <div xmlns="http://www.w3.org/1999/xhtml" style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              {React.isValidElement(Icon) ? 
                React.cloneElement(Icon, { size, color }) : 
                <Icon size={size} color={color} />
              }
            </div>
          </foreignObject>
          
          <defs>
            <filter id="filter0_ddiiii_normal" x="0" y="0" width="54" height="54" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
              <feFlood floodOpacity="0" result="BackgroundImageFix"/>
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
              <feOffset dx="-1" dy="-1"/>
              <feGaussianBlur stdDeviation="1"/>
              <feColorMatrix type="matrix" values={`0 0 0 0 ${shadows.mid.r} 0 0 0 0 ${shadows.mid.g} 0 0 0 0 ${shadows.mid.b} 0 0 0 0.5 0`}/>
              <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_normal"/>
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
              <feOffset dx="1" dy="1"/>
              <feGaussianBlur stdDeviation="1"/>
              <feColorMatrix type="matrix" values={`0 0 0 0 ${shadows.accent.r} 0 0 0 0 ${shadows.accent.g} 0 0 0 0 ${shadows.accent.b} 0 0 0 0.3 0`}/>
              <feBlend mode="normal" in2="effect1_dropShadow_normal" result="effect2_dropShadow_normal"/>
              <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_normal" result="shape"/>
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
              <feOffset dx="3" dy="3"/>
              <feGaussianBlur stdDeviation="4"/>
              <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
              <feColorMatrix type="matrix" values={`0 0 0 0 ${shadows.mid.r} 0 0 0 0 ${shadows.mid.g} 0 0 0 0 ${shadows.mid.b} 0 0 0 0.9 0`}/>
              <feBlend mode="normal" in2="shape" result="effect3_innerShadow_normal"/>
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
              <feOffset dx="-3" dy="-3"/>
              <feGaussianBlur stdDeviation="3"/>
              <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
              <feColorMatrix type="matrix" values={`0 0 0 0 ${shadows.accent.r} 0 0 0 0 ${shadows.accent.g} 0 0 0 0 ${shadows.accent.b} 0 0 0 0.9 0`}/>
              <feBlend mode="normal" in2="effect3_innerShadow_normal" result="effect4_innerShadow_normal"/>
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
              <feOffset dx="3" dy="-3"/>
              <feGaussianBlur stdDeviation="3"/>
              <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
              <feColorMatrix type="matrix" values={`0 0 0 0 ${shadows.mid.r} 0 0 0 0 ${shadows.mid.g} 0 0 0 0 ${shadows.mid.b} 0 0 0 0.2 0`}/>
              <feBlend mode="normal" in2="effect4_innerShadow_normal" result="effect5_innerShadow_normal"/>
              <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
              <feOffset dx="-3" dy="3"/>
              <feGaussianBlur stdDeviation="3"/>
              <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
              <feColorMatrix type="matrix" values={`0 0 0 0 ${shadows.mid.r} 0 0 0 0 ${shadows.mid.g} 0 0 0 0 ${shadows.mid.b} 0 0 0 0.2 0`}/>
              <feBlend mode="normal" in2="effect5_innerShadow_normal" result="effect6_innerShadow_normal"/>
            </filter>
          </defs>
        </svg>
      )}
    </div>
  );
};

export default TopNavBtn;